export default (query) =>
  /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9]))(\.[a-z0-9][a-z0-9-]{0,61}[a-z0-9])*$/i.test(query);
